import { getCustomSkillLevelId } from '../../next/CustomDash/filters/utils/customSkillTaxonomyRegistry';
import { SKILL_REFERENCE_TAXONOMY_TREE_LEVELS } from '../../next/CustomDash/filters/utils/skillReferenceTaxonomyTree';
import { SKILL_TAXONOMY_SELECTION_LIST_KEYS } from '../selection-lists/types';

/**
 * `skills_level_N` names an API level, and which tier of the account's skill
 * ladder that is depends on the taxonomy the account uses — the registry holds
 * the live answer once its tree has loaded, the reference ladder before then.
 */
export const skillLevelName = (apiLevel: number): string | undefined => {
  const keys = SKILL_TAXONOMY_SELECTION_LIST_KEYS;
  for (const [tier, key] of keys.entries()) {
    const level =
      getCustomSkillLevelId(key) ?? SKILL_REFERENCE_TAXONOMY_TREE_LEVELS[tier];
    if (level === apiLevel) {
      return `Skill tier ${tier + 1} of ${keys.length} (level ${apiLevel})`;
    }
  }
  return undefined;
};
